import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalRole } from '../models/modal-roles';
import { StateService } from '../../public-api';

@Component({
  selector: 'lib-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  standalone: false,
})
export class HelpComponent {
  constructor(private modalCtrl: ModalController, public state: StateService) {}
  public cancel() {
    return this.modalCtrl.dismiss(null, ModalRole.Cancel);
  }
}
